module.exports = __webpack_public_path__ + "img/00029.2b02e211.webp";